var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: "添加文档",
            visible: _vm.dialog,
            modal: false,
            "close-on-click-modal": false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialog = $event
            },
            close: function($event) {
              return _vm.resetForm("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                model: _vm.paramsData,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "title", label: "标题" }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.paramsData.title,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "title", $$v)
                      },
                      expression: "paramsData.title"
                    }
                  })
                ],
                1
              ),
              _vm.rawData.game_mark.indexOf("yjfm") == -1
                ? [
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "flex-1",
                            attrs: { filterable: "", placeholder: "请选择" },
                            on: { change: _vm.getServer },
                            model: {
                              value: _vm.paramsData.is_prod,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "is_prod", $$v)
                              },
                              expression: "paramsData.is_prod"
                            }
                          },
                          _vm._l(_vm.severlist, function(item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "flex-1",
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择服务器"
                            },
                            on: { change: _vm.YjfmSeverChange },
                            model: {
                              value: _vm.paramsData.server_id,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "server_id", $$v)
                              },
                              expression: "paramsData.server_id"
                            }
                          },
                          _vm._l(_vm.serverList, function(item) {
                            return _c("el-option", {
                              key: item.serverID,
                              attrs: {
                                label: item.serverName,
                                value: item.serverID
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "flex-1",
                            attrs: { filterable: "", placeholder: "请选择" },
                            on: { change: _vm.envIdChange },
                            model: {
                              value: _vm.paramsData.env_id,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "env_id", $$v)
                              },
                              expression: "paramsData.env_id"
                            }
                          },
                          _vm._l(_vm.szgmEnv, function(item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.label, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "服务器渠道"
                            },
                            on: { change: _vm.serverChange },
                            model: {
                              value: _vm.server_channel,
                              callback: function($$v) {
                                _vm.server_channel = $$v
                              },
                              expression: "server_channel"
                            }
                          },
                          _vm._l(_vm.serverChannel, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: "是否展示测试服"
                            },
                            on: { change: _vm.serverChannelChange },
                            model: {
                              value: _vm.show_test,
                              callback: function($$v) {
                                _vm.show_test = $$v
                              },
                              expression: "show_test"
                            }
                          },
                          _vm._l(_vm.serverType, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", placeholder: "服务器" },
                            on: { change: _vm.severChange },
                            model: {
                              value: _vm.paramsData.server_id,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "server_id", $$v)
                              },
                              expression: "paramsData.server_id"
                            }
                          },
                          _vm._l(_vm.serverListYJ, function(item) {
                            return _c("el-option", {
                              key: item.serverID,
                              attrs: {
                                label: item.serverName,
                                value: item.serverID
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.resetForm("ruleForm")
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }